<template>
    <!-- On the tool's screens the tool is the active method; picking another one goes back to
         Kayıp Güç, which asks before discarding the tool's rows. -->
    <calc-method-cards :active="2" :show-measured="$store.state.ratedCurrentIndex == 1" @select="changeTab" />
</template>

<script>
    import router from '@/router';
    import CalcMethodCards from '@/components/CalcMethodCards.vue';

    export default {
        name: 'CalculationTabs',
        components: {
            CalcMethodCards
        },
        methods: {
            // Only says which method was picked. This used to write calcIndex before the
            // confirmation too, so "Vazgeç" left the store on the other method with the tool's
            // rows still in place.
            changeTab(index) {
                if (index === 2) {
                    return;
                }
                this.$store.state.calcIndexFromOutputCircs = index;
                this.$store.state.currentRouteFromOutputCircs = this.$route.name;
                router.push('/calculation');
            }
        }
    };
</script>
